import { FC } from 'react';
import { DataSourcesTable } from './DataSourcesTable/DataSourcesTable';
import { DataSourcesTableSearch } from './DataSourcesTable/DataSourcesTableSearch';

export const DataSourcesList: FC = () => {
  return (
    <div className='flex flex-col gap-4'>
      <DataSourcesTableSearch />
      <DataSourcesTable />
    </div>
  );
};
